import React, { useContext, useEffect, useState } from "react";
import { Grid, Typography, CircularProgress, InputAdornment } from "@material-ui/core";
import { InputField } from "../../FormFields";
import { AuthContext } from "../../../context/Auth/AuthContext";
import axios from "axios";

export default function AddressForm(props) {
  const { user } = useContext(AuthContext);
  const co = user.company;

  const [name,         setName]         = useState(co.name                  || "");
  const [document,     setDocument]     = useState(co.document               || "");
  const [email,        setEmail]        = useState(co.email || user.email    || "");
  const [phone,        setPhone]        = useState(co.phone                  || "");
  const [zipCode,      setZipCode]      = useState(co.addressZipCode         || "");
  const [street,       setStreet]       = useState(co.addressStreet          || "");
  const [number,       setNumber]       = useState(co.addressNumber          || "");
  const [neighborhood, setNeighborhood] = useState(co.addressNeighborhood    || "");
  const [city,         setCity]         = useState(co.addressCity            || "");
  const [state,        setState]        = useState(co.addressState           || "");
  const [cepLoading,   setCepLoading]   = useState(false);

  const { setFieldValue, errors, touched } = props;

  useEffect(() => {
    setFieldValue("firstName",           name);
    setFieldValue("zipcode",             document);
    setFieldValue("email",               email);
    setFieldValue("phone",               phone);
    setFieldValue("address2",            street);
    setFieldValue("addressNumber",       number);
    setFieldValue("addressNeighborhood", neighborhood);
    setFieldValue("city",                city);
    setFieldValue("state",               state);
    setFieldValue("addressZipCode",      zipCode);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCep = async (cep) => {
    const clean = cep.replace(/\D/g, "");
    setZipCode(cep);
    setFieldValue("addressZipCode", cep);
    if (clean.length === 8) {
      setCepLoading(true);
      try {
        const { data } = await axios.get(`https://viacep.com.br/ws/${clean}/json/`);
        if (!data.erro) {
          setStreet(data.logradouro || "");    setFieldValue("address2",            data.logradouro || "");
          setNeighborhood(data.bairro || "");  setFieldValue("addressNeighborhood", data.bairro     || "");
          setCity(data.localidade || "");      setFieldValue("city",                data.localidade || "");
          setState(data.uf || "");             setFieldValue("state",               data.uf         || "");
        }
      } catch {}
      setCepLoading(false);
    }
  };

  const formatDoc = (v) => {
    const d = v.replace(/\D/g, "");
    if (d.length <= 11) {
      if (d.length > 9) return d.replace(/(\d{3})(\d{3})(\d{3})(\d{1,2})/, "$1.$2.$3-$4");
      if (d.length > 6) return d.replace(/(\d{3})(\d{3})(\d{1,3})/, "$1.$2.$3");
      if (d.length > 3) return d.replace(/(\d{3})(\d{1,3})/, "$1.$2");
      return d;
    }
    if (d.length > 12) return d.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{1,2})/, "$1.$2.$3/$4-$5");
    if (d.length > 8)  return d.replace(/(\d{2})(\d{3})(\d{3})(\d{1,4})/, "$1.$2.$3/$4");
    return d;
  };

  const formatPhone = (v) => {
    const d = v.replace(/\D/g, "").slice(0, 11);
    if (d.length === 11) return d.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
    if (d.length === 10) return d.replace(/(\d{2})(\d{4})(\d{4})/, "($1) $2-$3");
    if (d.length > 6)   return d.replace(/(\d{2})(\d{4,5})(\d*)/, "($1) $2-$3");
    if (d.length > 2)   return d.replace(/(\d{2})(\d*)/, "($1) $2");
    return d;
  };

  return (
    <React.Fragment>
      <Typography variant="subtitle1" style={{ marginBottom: 12, fontWeight: 600 }}>
        Dados de cobrança (necessários para nota fiscal)
      </Typography>
      <Grid container spacing={2}>

        <Grid item xs={12} sm={8}>
          <InputField name="firstName" label="Nome completo / Razão Social *" fullWidth
            value={name}
            onChange={(e) => { setName(e.target.value); setFieldValue("firstName", e.target.value); }} />
        </Grid>

        <Grid item xs={12} sm={4}>
          <InputField name="zipcode" label="CPF / CNPJ *" fullWidth
            value={document}
            onChange={(e) => { const f = formatDoc(e.target.value); setDocument(f); setFieldValue("zipcode", f); }}
            error={touched && touched.zipcode && Boolean(errors && errors.zipcode)}
            helperText={touched && touched.zipcode && errors && errors.zipcode} />
        </Grid>

        <Grid item xs={12} sm={6}>
          <InputField name="email" label="E-mail *" fullWidth
            value={email}
            onChange={(e) => { setEmail(e.target.value); setFieldValue("email", e.target.value); }} />
        </Grid>

        <Grid item xs={12} sm={6}>
          <InputField name="phone" label="Telefone / WhatsApp *" fullWidth
            value={phone}
            onChange={(e) => { const f = formatPhone(e.target.value); setPhone(f); setFieldValue("phone", f); }} />
        </Grid>

        <Grid item xs={12} sm={4}>
          <InputField name="addressZipCode" label="CEP" fullWidth
            value={zipCode}
            onChange={(e) => handleCep(e.target.value)}
            InputProps={cepLoading ? { endAdornment: <InputAdornment position="end"><CircularProgress size={16} /></InputAdornment> } : undefined}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <InputField name="address2" label="Rua / Avenida" fullWidth
            value={street}
            onChange={(e) => { setStreet(e.target.value); setFieldValue("address2", e.target.value); }} />
        </Grid>

        <Grid item xs={12} sm={2}>
          <InputField name="addressNumber" label="Número" fullWidth
            value={number}
            onChange={(e) => { setNumber(e.target.value); setFieldValue("addressNumber", e.target.value); }} />
        </Grid>

        <Grid item xs={12} sm={4}>
          <InputField name="addressNeighborhood" label="Bairro" fullWidth
            value={neighborhood}
            onChange={(e) => { setNeighborhood(e.target.value); setFieldValue("addressNeighborhood", e.target.value); }} />
        </Grid>

        <Grid item xs={12} sm={5}>
          <InputField name="city" label="Cidade" fullWidth
            value={city}
            onChange={(e) => { setCity(e.target.value); setFieldValue("city", e.target.value); }} />
        </Grid>

        <Grid item xs={12} sm={3}>
          <InputField name="state" label="Estado (UF)" fullWidth
            value={state}
            onChange={(e) => { setState(e.target.value); setFieldValue("state", e.target.value); }} />
        </Grid>

      </Grid>
    </React.Fragment>
  );
}
